import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { Modal } from '../../../components';
import ListadoTiposContactos from './components/ListadoTiposContactos';
import FormTiposContactos from './components/FormTiposContactos';
import {
  getAllTiposContactosAction,
  setActivoTiposContactosAction,
} from './TiposContactosAction';
import BotonNuevoComponent from '../../entidades/components/BotonNuevo';
import { checkRootAccess } from '../../modulos/modules.helpers';

const TiposContactosView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const tiposContactosStore = Redux.useSelector(
    (state) => state.tiposContactos
  );

  const loginStore = Redux.useSelector((state) => state.login);
  checkRootAccess(loginStore);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonNuevoComponent
          click={async () => {
            await setActivoTiposContactosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          azul
          mr={2}
        />
        {tiposContactosStore.all.length > 0 ? (
          <BotonNuevoComponent
            click={async () => {
              await setActivoTiposContactosAction(dispatch, null);
              await getAllTiposContactosAction(
                dispatch,
                entidadesStore.activo.id,
                null
              );
            }}
            disabled={tiposContactosStore.loadingGetAll}
            white
            text={
              tiposContactosStore.loadingGetAll
                ? 'Actualizando...'
                : 'Actualizar'
            }
          />
        ) : null}
      </Grid>
      <Grid item md={12}>
        <ListadoTiposContactos
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <Modal
        id="modalFormTiposContactos"
        title={`${
          tiposContactosStore.activo ? 'Editar' : 'Nuevo'
        } tipo de contacto`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {tiposContactosStore.activo ? (
          <Typography variant="h6">
            {tiposContactosStore.activo.nombres}{' '}
            {tiposContactosStore.activo.apellidos}
          </Typography>
        ) : null}
        <FormTiposContactos
          activo={tiposContactosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Modal>
    </Grid>
  );
};

export default TiposContactosView;
